<section class="activity-log">
  <header class="activity-log__header">
    <div>
      <h2 class="activity-log__title">Registro de actividad</h2>
      <p class="activity-log__subtitle">Acciones hechas en el panel. Usa "Copiar" para enviarle un registro al desarrollador.</p>
    </div>
  </header>

  <div class="activity-log__filters">
    <label class="activity-log__filter">
      <span class="activity-log__filter-label">Tipo</span>
      <select class="activity-log__filter-input" [value]="entityTypeFilter()" (change)="onEntityTypeChange($event)">
        <option value="">Todos</option>
        @for (option of entityTypeOptions; track option.value) {
          <option [value]="option.value">{{ option.label }}</option>
        }
      </select>
    </label>

    <label class="activity-log__filter">
      <span class="activity-log__filter-label">Acción</span>
      <select class="activity-log__filter-input" [value]="actionFilter()" (change)="onActionChange($event)">
        <option value="">Todas</option>
        @for (option of actionOptions; track option.value) {
          <option [value]="option.value">{{ option.label }}</option>
        }
      </select>
    </label>

    <label class="activity-log__filter">
      <span class="activity-log__filter-label">Desde</span>
      <input class="activity-log__filter-input" type="date" [value]="fromDateFilter()" (change)="onFromDateChange($event)" />
    </label>

    <label class="activity-log__filter">
      <span class="activity-log__filter-label">Hasta</span>
      <input class="activity-log__filter-input" type="date" [value]="toDateFilter()" (change)="onToDateChange($event)" />
    </label>

    @if (hasActiveFilters()) {
      <button type="button" class="activity-log__clear-btn" (click)="clearFilters()">Limpiar filtros</button>
    }
  </div>

  @if (hasLoadError()) {
    <div class="activity-log__state activity-log__state--error">
      <p>No pudimos cargar el registro de actividad.</p>
      <button type="button" class="activity-log__retry-btn" (click)="loadPage(currentPage())">Reintentar</button>
    </div>
  } @else if (isLoading() && auditLogs().length === 0) {
    <p class="activity-log__state">Cargando actividad...</p>
  } @else {
    <div class="activity-log__table-container" [class.activity-log__table-container--refreshing]="isLoading()">
      <table class="activity-log__table">
        <thead>
          <tr>
            <th scope="col">Fecha</th>
            <th scope="col">Admin</th>
            <th scope="col">Acción</th>
            <th scope="col">Entidad</th>
            <th scope="col">Cambios</th>
            <th scope="col"><span class="activity-log__visually-hidden">Copiar</span></th>
          </tr>
        </thead>

        <tbody>
          @for (auditLog of auditLogs(); track auditLog.id) {
            <tr>
              <td class="activity-log__date">{{ formatDate(auditLog) }}</td>
              <td class="activity-log__actor">{{ auditLog.actorEmail }}</td>
              <td>
                <span class="activity-log__action" [attr.data-action]="auditLog.action">{{ actionLabel(auditLog) }}</span>
              </td>
              <td>
                <span class="activity-log__entity-type">{{ entityTypeLabel(auditLog) }}</span>
                <span class="activity-log__entity-label">{{ auditLog.entityLabel ?? auditLog.entityId }}</span>
              </td>
              <td class="activity-log__changes">
                @for (changeLine of changeLines(auditLog); track changeLine.fieldLabel) {
                  <div class="activity-log__change" [title]="changeLine.fieldLabel + ': ' + changeLine.before + ' → ' + changeLine.after">
                    <span class="activity-log__change-field">{{ changeLine.fieldLabel }}:</span>
                    <span class="activity-log__change-before">{{ changeLine.before }}</span>
                    <span class="activity-log__change-arrow" aria-hidden="true">→</span>
                    <span class="activity-log__change-after">{{ changeLine.after }}</span>
                  </div>
                } @empty {
                  <span class="activity-log__no-changes">{{ changedFieldsLabel(auditLog) || '—' }}</span>
                }
              </td>
              <td>
                <button
                  type="button"
                  class="activity-log__copy-btn"
                  [attr.aria-label]="'Copiar registro de ' + entityTypeLabel(auditLog) + ' ' + (auditLog.entityLabel ?? auditLog.entityId)"
                  (click)="copyAuditLog(auditLog)"
                >
                  Copiar
                </button>
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="6" class="activity-log__state">No hay actividad registrada en este periodo.</td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <app-pagination theme="admin" [currentPage]="currentPage()" [totalPages]="totalPages()" (pageChange)="onPageChange($event)" />
  }
</section>
